<page-header [section]="'audit-history'">
  <page-title>Audit History</page-title>
  <page-blurb>View and manage audit logs.</page-blurb>
</page-header>
